import { render, staticRenderFns } from "./KarteInfoChannel.vue?vue&type=template&id=33b20c98&"
import script from "./KarteInfoChannel.vue?vue&type=script&lang=ts&"
export * from "./KarteInfoChannel.vue?vue&type=script&lang=ts&"
import style0 from "./KarteInfoChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports